import React from "react";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import jssVariables from "../../../jss_setup";
import { Placeholder } from "rsuite";
import { InlineIcon } from "@iconify/react";

const styles = createUseStyles({
  placeholderParagraph: (props) => ({
    width: "100%!important",
    minWidth: "10rem",
    ..._.get(props, "customStyles.customStyles", {}),
  }),
  placeholderGraph: (props) => ({
    width: "10rem!important",
    height: "6rem!important",
    ..._.get(props, "customStyles.customStyles", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const PlaceholderPrebook = () => {
  const classes = styles({});
  return (
    <React.Fragment>
      <Placeholder.Paragraph
        rows={1}
        active
        className={classes.placeholderParagraph}
      />
      <br />
      <Placeholder.Graph active className={classes.placeholderGraph} />
      <br />

      <span style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
        <Placeholder.Paragraph
          rows={3}
          active
          className={classes.placeholderParagraph}
        />
        <Placeholder.Paragraph
          rows={3}
          active
          className={classes.placeholderParagraph}
        />
      </span>
      <br />
      <Placeholder.Paragraph
        rows={1}
        active
        className={classes.placeholderParagraph}
      />
      <span
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gridGap: jssVariables.normal_gap,
        }}>
        <Placeholder.Paragraph
          rows={3}
          active
          className={classes.placeholderParagraph}
        />
        <Placeholder.Paragraph
          rows={4}
          active
          className={classes.placeholderParagraph}
        />
      </span>
      <br />
      <div className={classes.extraInfo}>
        <Placeholder.Paragraph
          rows={2}
          active
          className={classes.placeholderParagraph}
        />
        <br />
      </div>
    </React.Fragment>
  );
};
